import { useCallback, useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import { Edit as EditIcon } from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DataGrid } from "@mui/x-data-grid";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PermissionEnum } from "@/features/permissions";
import { apiClient, getErrorMessage } from "@/features/shared";
import { SearchTextField, useSnackbar } from "@/features/ui";
import { useSearchFilter, useServerPagination } from "@/hooks";

export const Roles = () => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const { setRowCount, paginationParams, dataGridPaginationProps, resetParams } =
    useServerPagination();
  const { keyword, searchProps } = useSearchFilter({ resetParams });

  const loadRoles = useCallback(async () => {
    setLoading(true);
    try {
      const {
        data: { data, pageInfo },
      } = await apiClient.get("roles", {
        params: {
          ...paginationParams,
          ...(keyword && { name: keyword }),
        },
      });
      setRoles(data);
      setRowCount(pageInfo.totalItems);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memuat peran"));
    } finally {
      setLoading(false);
    }
  }, [paginationParams, keyword, setRowCount, showSnackbar]);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  const toolbarContent = hasPermission(PermissionEnum.CREATE_ROLES) && (
        <Button variant="contained" component={Link} to="create">
          Tambah
        </Button>
      );

  return (
    <PageContainer maxWidth="xl" breadcrumbs={[]} slotProps={{ header: { slotProps: { toolbar: { children: toolbarContent } } } }}>
      <Stack spacing={3}>
        <Grid container sx={{ justifyContent: "flex-end" }}>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <SearchTextField
              fullWidth
              placeholder="Cari nama"
              {...searchProps}
            />
          </Grid>
        </Grid>
        <DataGrid
          rows={roles}
          loading={loading}
          getRowHeight={() => "auto"}
          columns={[
            {
              field: "name",
              headerName: "Nama",
              flex: 3,
              sortable: false,
            },
            {
              field: "permissions",
              headerName: "Jumlah Hak Akses",
              flex: 1,
              sortable: false,
              valueGetter: (value) => value.length,
            },
            ...(hasPermission(PermissionEnum.UPDATE_ROLES)
              ? [
                  {
                    field: "actions",
                    type: "actions",
                    headerName: "Aksi",
                    getActions: (params) => [
                      <IconButton
                        key="edit"
                        onClick={() => navigate(`${params.id}/edit`)}
                        size="small"
                      >
                        <EditIcon />
                      </IconButton>,
                    ],
                  },
                ]
              : []),
          ]}
          {...dataGridPaginationProps}
          disableRowSelectionOnClick
        />
      </Stack>
    </PageContainer>
  );
};
